// import React, { useState } from 'react';
// import { 
//   Scale, BookOpen, MessageSquare, ShieldCheck, 
//   Briefcase, Landmark, ShieldAlert, Users, 
//   Building2, Home, FileText, Percent, CheckCircle
// } from 'lucide-react'; // Make sure to run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function LegalConsultations() {
//   const [activeTab, setActiveTab] = useState(0);

//   // Forms / Formats of Consultations
//   const formats = [
//     {
//       title: "استشارات شفهية تفصيلية",
//       description: "نناقش قضيتك معك بشكل مباشر ونشرح كل السيناريوهات المحتملة بدقة ووضوح.",
//       icon: <MessageSquare className="w-8 h-8 text-amber-600" />
//     },
//     {
//       title: "استشارات مكتوبة رسمية",
//       description: "تقارير وتحاليل قانونية موثقة يمكنك الاعتماد عليها وتقديمها أمام أي جهة رسمية.",
//       icon: <FileText className="w-8 h-8 text-amber-600" />
//     },
//     {
//       title: "استشارات رقمية سريعة",
//       description: "تواصل مرن عبر الإنترنت لتحصل على نصائح قانونية فورية دون الحاجة للحضور الشخصي.",
//       icon: <BookOpen className="w-8 h-8 text-amber-600" />
//     }
//   ];

//   // Scope of Legal Practice
//   const practiceAreas = [
//     { name: "القضايا التجارية", icon: <Briefcase className="w-6 h-6" />, desc: "استشارات في تأسيس الشركات، النزاعات التجارية، والامتثال للأنظمة." },
//     { name: "القضايا الجنائية", icon: <ShieldAlert className="w-6 h-6" />, desc: "تحليل الأدلة واللوائح الجزائية، الجرائم المعلوماتية، وقضايا التزوير." },
//     { name: "القضايا المدنية والإدارية", icon: <Landmark className="w-6 h-6" />, desc: "منازعات العقود، التعويضات، المسؤولية المدنية، والقرارات الإدارية." },
//     { name: "القضايا العقارية", icon: <Home className="w-6 h-6" />, desc: "النزاعات العقارية، التملك، الصكوك، ومنازعات الإيجار والبيع." },
//     { name: "القضايا العمالية", icon: <Users className="w-6 h-6" />, desc: "فهم نظام العمل السعودي، العقود العمالية، الفصل، والأجور." },
//     { name: "قضايا الأحوال الشخصية", icon: <Building2 className="w-6 h-6" />, desc: "استشارات الزواج، الطلاق، النفقة، الحضانة، الميراث، والوصايا." },
//     { name: "المنازعات الضريبية والتمويلية", icon: <Percent className="w-6 h-6" />, desc: "التحليل القانوني للضرائب، الزكاة، القروض، ومطالبات التأمين البنكية." }
//   ];

//   // Why Choose Us features
//   const features = [
//     "فريق من المحامين المتخصصين والمتابعين باستمرار للتحديثات التشريعية في المملكة.",
//     "التزام صارم بالمصداقية، الشفافية، والحيادية المطلقة في تقديم المشورة.",
//     "استخدام أحدث الوسائل الرقمية لتقديم استشارات سريعة، دقيقة وفعالة.",
//     "الحفاظ التام على خصوصية وسرية معلوماتك مع احترام تام لوقتك."
//   ];

//   return (
//     <div className="bg-gray-50 text-right min-h-screen font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="الاستشارات القانونية المتخصصة"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header */}
//       <section className="relative bg-slate-900 text-white py-20 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold tracking-wider text-sm md:text-base block mb-3">خدماتنا المتميزة</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">الاستشارات القانونية المتخصصة</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             الاستشارة القانونية تُعتبر خطوة لا غنى عنها لأي شخص أو جهة ترغب في حماية حقوقها أو التعامل مع قضايا قانونية معقدة في بيئة الأنظمة التشريعية والقضائية.
//           </p>
//         </div>
//       </section>

//       {/* Intro Description */}
//       <section className="max-w-6xl mx-auto py-16 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col md:flex-row items-center gap-8">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-4">ما هي الاستشارة القانونية لدينا؟</h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               الاستشارة القانونية ليست مجرد نصيحة عابرة، بل هي دراسة مستفيضة ومتأنية لموقفك القانوني من قبل خبراء متخصصين. نقدم لك الرأي القانوني المدعوم بالأسس التشريعية والقضائية التي تنطبق تماماً على حالتك.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               سواء كنت تواجه نزاعاً قائماً، أو تخطط لاتخاذ خطوة استباقية كعقود أو شراكات، فإننا نوفر لك تصوراً واضحاً يقيك المخاطر ويعزز من مركزك القانوني.
//             </p>
//           </div>
//           <div className="bg-slate-100 p-6 rounded-xl flex items-center justify-center border border-slate-200">
//             <Scale className="w-24 h-24 text-slate-700" />
//           </div>
//         </div>
//       </section>

//       {/* Shapes of Consultations */}
//       <section className="bg-slate-100 py-16 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-2">أشكال الاستشارات القانونية التي نقدمها</h2>
//             <p className="text-gray-500">نقدم الاستشارة بالطريقة التي تناسب احتياجاتك وظروفك</p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {formats.map((item, index) => (
//               <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
//                 <div className="mb-4 inline-block p-3 bg-amber-50 rounded-lg">
//                   {item.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-800 mb-3">{item.title}</h3>
//                 <p className="text-gray-600 leading-relaxed">{item.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Scope of Services Grid */}
//       <section className="max-w-6xl mx-auto py-16 px-4">
//         <div className="text-center mb-12">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-2">نطاق خدماتنا القانونية الواسعة</h2>
//           <p className="text-gray-500">تغطية قانونية شاملة لكافة القطاعات والأنظمة في المملكة العربية السعودية</p>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {practiceAreas.map((area, index) => (
//             <div key={index} className="group bg-white p-6 rounded-xl border border-gray-200 hover:border-amber-500 transition-all duration-300 shadow-sm flex gap-4">
//               <div className="text-slate-700 group-hover:text-amber-600 transition-colors p-3 bg-slate-50 rounded-lg h-fit">
//                 {area.icon}
//               </div>
//               <div>
//                 <h3 className="text-lg font-bold text-slate-800 mb-1 group-hover:text-amber-600 transition-colors">{area.name}</h3>
//                 <p className="text-gray-500 text-sm leading-relaxed">{area.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Why Us Section */}
//       <section className="bg-slate-900 text-white py-16 px-4">
//         <div className="max-w-4xl mx-auto">
//           <div className="flex items-center gap-3 mb-8 justify-center">
//             <ShieldCheck className="w-8 h-8 text-amber-500" />
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-100">بماذا نتميز في تقديم الاستشارات؟</h2>
//           </div>

//           <div className="space-y-4">
//             {features.map((feature, index) => (
//               <div key={index} className="flex items-start gap-3 bg-slate-800/50 p-4 rounded-xl border border-slate-700">
//                 <CheckCircle className="w-6 h-6 text-amber-500 shrink-0 mt-0.5" />
//                 <p className="text-slate-300 text-base md:text-lg leading-relaxed">{feature}</p>
//               </div>
//             ))}
//           </div>
          
//           <div className="text-center mt-12">
//             <a 
//               href="#contact" 
//               className="inline-block bg-amber-600 text-white font-bold px-8 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-lg"
//             >
//               اطلب استشارة قانونية فورية
//             </a>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }

import React, { useState } from 'react';
import { 
  Scale, BookOpen, MessageSquare, ShieldCheck, 
  Briefcase, Landmark, ShieldAlert, Users, 
  Building2, Home, FileText, Percent, CheckCircle
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function LegalConsultations() {
  const [activeTab, setActiveTab] = useState(0);

  // Forms / Formats of Consultations - Refactored to Navy Light
  const formats = [
    {
      title: "استشارات شفهية تفصيلية",
      description: "نناقش قضيتك معك بشكل مباشر ونشرح كل السيناريوهات المحتملة بدقة ووضوح.",
      icon: <MessageSquare className="w-8 h-8 text-indigo-950" />
    },
    {
      title: "استشارات مكتوبة رسمية",
      description: "تقارير وتحاليل قانونية موثقة يمكنك الاعتماد عليها وتقديمها أمام أي جهة رسمية.",
      icon: <FileText className="w-8 h-8 text-indigo-950" />
    },
    {
      title: "استشارات رقمية سريعة",
      description: "تواصل مرن عبر الإنترنت لتحصل على نصائح قانونية فورية دون الحاجة للحضور الشخصي.",
      icon: <BookOpen className="w-8 h-8 text-indigo-950" />
    }
  ];

  // Scope of Legal Practice - Updated Icons Style
  const practiceAreas = [
    { name: "القضايا التجارية", icon: <Briefcase className="w-6 h-6" />, desc: "استشارات في تأسيس الشركات، النزاعات التجارية، والامتثال للأنظمة." },
    { name: "القضايا الجنائية", icon: <ShieldAlert className="w-6 h-6" />, desc: "تحليل الأدلة واللوائح الجزائية، الجرائم المعلوماتية، وقضايا التزوير." },
    { name: "القضايا المدنية والإدارية", icon: <Landmark className="w-6 h-6" />, desc: "منازعات العقود، التعويضات، المسؤولية المدنية، والقرارات الإدارية." },
    { name: "القضايا العقارية", icon: <Home className="w-6 h-6" />, desc: "النزاعات العقارية، التملك، الصكوك، ومنازعات الإيجار والبيع." },
    { name: "القضايا العمالية", icon: <Users className="w-6 h-6" />, desc: "فهم نظام العمل السعودي، العقود العمالية، الفصل، والأجور." },
    { name: "قضايا الأحوال الشخصية", icon: <Building2 className="w-6 h-6" />, desc: "استشارات الزواج، الطلاق، النفقة، الحضانة، الميراث، والوصايا." },
    { name: "المنازعات الضريبية والتمويلية", icon: <Percent className="w-6 h-6" />, desc: "التحليل القانوني للضرائب، الزكاة، القروض، ومطالبات التأمين البنكية." }
  ];

  // Why Choose Us features
  const features = [
    "فريق من المحامين المتخصصين والمتابعين باستمرار للتحديثات التشريعية في المملكة.",
    "التزام صارم بالمصداقية، الشفافية، والحيادية المطلقة في تقديم المشورة.",
    "استخدام أحدث الوسائل الرقمية لتقديم استشارات سريعة، دقيقة وفعالة.",
    "الحفاظ التام على خصوصية وسرية معلوماتك مع احترام تام لوقتك."
  ];

  return (
    <div className="bg-white text-right min-h-screen font-sans" dir="rtl">
      <ServicePageHeader 
        title="الاستشارات القانونية المتخصصة"
        description="نقدم حلولاً قانونية وشرعية متكاملة لتوفير الرأي القانوني السديد ودعم قراراتك الاستراتيجية"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('[https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80](https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80)'        )] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">خدماتنا المتميزة والموثوقة</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">الاستشارات القانونية المتخصصة</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            الاستشارة القانونية تُعتبر خطوة لا غنى عنها لأي شخص أو جهة ترغب في حماية حقوقها أو التعامل مع قضايا قانونية معقدة في بيئة الأنظمة التشريعية والقضائية.
          </p>
        </div>
      </section>

      {/* Intro Description */}
      <section className="max-w-6xl mx-auto py-16 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-extrabold text-indigo-950 mb-4">ما هي الاستشارة القانونية لدينا؟</h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              الاستشارة القانونية ليست مجرد نصيحة عابرة، بل هي دراسة مستفيضة ومتأنية لموقفك القانوني من قبل خبراء متخصصين. نقدم لك الرأي القانوني المدعوم بالأسس التشريعية والقضائية التي تنطبق تماماً على حالتك.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              سواء كنت تواجه نزاعاً قائماً، أو تخطط لاتخاذ خطوة استباقية كعقود أو شراكات، فإننا نوفر لك تصوراً واضحاً يقيك المخاطر ويعزز من مركزك القانوني.
            </p>
          </div>
          <div className="bg-slate-50 p-6 rounded-xl flex items-center justify-center border border-slate-200/60 shrink-0">
            <Scale className="w-24 h-24 text-indigo-950" />
          </div>
        </div>
      </section>

      {/* Shapes of Consultations - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-2">أشكال الاستشارات القانونية التي نقدمها</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">نقدم الاستشارة بالطريقة التي تناسب احتياجاتك وظروفك التشغيلية</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {formats.map((item, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="mb-4 inline-block p-3 bg-slate-50 rounded-lg">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-3">{item.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Scope of Services Grid */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-2">نطاق خدماتنا القانونية الواسعة</h2>
          <p className="text-slate-500 text-sm md:text-base font-light">تغطية قانونية شاملة لكافة القطاعات والأنظمة في المملكة العربية السعودية</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {practiceAreas.map((area, index) => (
            <div key={index} className="group bg-white p-6 rounded-xl border border-slate-100 hover:border-indigo-950 transition-all duration-300 shadow-sm flex gap-4">
              <div className="text-indigo-950 group-hover:text-blue-700 transition-colors p-3 bg-slate-50 rounded-lg h-fit">
                {area.icon}
              </div>
              <div>
                <h3 className="text-lg font-bold text-indigo-950 mb-1 group-hover:text-blue-700 transition-colors">{area.name}</h3>
                <p className="text-slate-500 text-sm leading-relaxed font-light">{area.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Why Us Section - Converted to Premium Light Mode */}
      <section className="bg-slate-50/50 border-t border-slate-100 py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3 mb-10 justify-center">
            <ShieldCheck className="w-8 h-8 text-blue-700" />
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950">بماذا نتميز في تقديم الاستشارات؟</h2>
          </div>

          <div className="space-y-4">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-xl border border-slate-100 shadow-sm">
                <CheckCircle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
                <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">{feature}</p>
              </div>
            ))}
          </div>
          

{/* In your Card or Pricing loop component */}

<button 
  className="btn-primary" 
  onClick={() => openWhatsApp( "  اطلب استشارة قانونية فورية")}
>
              اطلب استشارة قانونية فورية
</button>



          {/* <div className="text-center mt-12">
            <button className="bg-indigo-950 text-white font-bold text-sm px-8 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm">
              اطلب استشارة قانونية فورية
            </button>
          </div>
 */}



        </div>
      </section>

    </div>
  );
}

